import { createContext, useState } from 'react';

const BeatBattleContext = createContext();

export const BeatBattleProvider = ({ children }) => {
  const [beatBattleData, setBeatBattleData] = useState(null);

  const clearBeatBattleData = () => setBeatBattleData(null);

  return (
    <BeatBattleContext.Provider value={{ beatBattleData, setBeatBattleData, clearBeatBattleData }}>
      {children}
    </BeatBattleContext.Provider>
  );
};

export default BeatBattleContext;
